
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/[...sid]",
      function () {
        return require("private-next-pages/dashboard/[...sid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/[...sid]"])
      });
    }
  